import { IStopBasicForShipper, IStopDetailedForShipper } from '../stop';
import { IFreightBasicForShipper, IFreightDetailedForShipper } from './freight-shipper.model';

export function transformToIFreightBasicFromIFreightDetailForShipper(
  freightDetailed: IFreightDetailedForShipper,
): IFreightBasicForShipper {
  return {
    id: freightDetailed.id,
    status: freightDetailed.status,
    reference: freightDetailed.reference,

    stopsBasic: Array.isArray(freightDetailed.stopsDetailed)
      ? freightDetailed.stopsDetailed.map(transformStopDetailToStopBasicForShipper)
      : [],

    nextStopId: freightDetailed.nextStopId,
    nextStopType: freightDetailed.nextStopType,
    nextStopStatus: freightDetailed.nextStopStatus,

    vehicles: freightDetailed.vehicles || [],
    drivers: freightDetailed.drivers || [],
    // invoiceList: freightDetailed.invoiceList || [],

    billingStatus: freightDetailed.billingStatus,
    scheduledKm: freightDetailed.scheduledKm,
    price: freightDetailed.price,
    deliveryNoteInPaperRequired: freightDetailed.deliveryNoteInPaperRequired,
    numberOfStops: freightDetailed.numberOfStops,
  };
}

function transformStopDetailToStopBasicForShipper(stopDetailed: IStopDetailedForShipper): IStopBasicForShipper {
  return {
    id: stopDetailed.id,
    position: stopDetailed.position,
    type: stopDetailed.type,
    since: stopDetailed.since,
    until: stopDetailed.until,
    status: stopDetailed.status,
    address: stopDetailed.address,
  };
}
